import { applyStoredColorScheme, mountColorSchemeStylesheet } from '@myosh/design-system'
import { AuthProvider, UserProvider } from '@myosh/myosh-login'
import { TooltipProvider } from '@myosh/odin-components'
import laraDark from 'primereact/resources/themes/lara-dark-indigo/theme.css?inline'
import laraLight from 'primereact/resources/themes/lara-light-indigo/theme.css?inline'
import React from 'react'
import { createRoot } from 'react-dom/client'
import { HelmetProvider } from 'react-helmet-async'
import { Provider } from 'react-redux'
import { BrowserRouter } from 'react-router'
import App from './App'
import Notifications from './components/UI/notifications/Notifications'
import Meta from './features/meta/meta'
import '@myosh/odin-translations/i18n'
import './index.css'
import store from './redux/store'

mountColorSchemeStylesheet(laraLight, 'light', 'primereact.theme')
mountColorSchemeStylesheet(laraDark, 'dark', 'primereact.theme')
applyStoredColorScheme()

const container = document.getElementById('root')
const root = createRoot(container as HTMLElement)

root.render(
  <React.StrictMode>
    <HelmetProvider>
      <Provider store={store}>
        <BrowserRouter basename={import.meta.env.BASE_URL}>
          <AuthProvider>
            <UserProvider>
              <TooltipProvider>
                <Meta />
                <App />
                <Notifications />
              </TooltipProvider>
            </UserProvider>
          </AuthProvider>
        </BrowserRouter>
      </Provider>
    </HelmetProvider>
  </React.StrictMode>
)
